import { render, staticRenderFns } from "./purposesCloudHistory.vue?vue&type=template&id=19bc28ce&scoped=true"
import script from "./purposesCloudHistory.vue?vue&type=script&lang=js"
export * from "./purposesCloudHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bc28ce",
  null
  
)

export default component.exports